import React, { useRef, useState } from "react";
import { Modal, Form, DatePicker, InputNumber, Upload } from "antd";
import { Button, Input, Select, Row, Col } from "antd";
import {
  CloseOutlined,
  FormOutlined,
  LoadingOutlined,
  SyncOutlined,
  CheckOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import Axios from "../../../api/Axios";
import dayjs from "dayjs";
import { uploadFileCourse } from "../../../pages/Admin-pages/CAAdminCoursePages/courseUtils";
const { Option } = Select;
const AddLMSPurchase = ({
  CreateSuccessfull,
  CreateFailed,
  org_id,
  org_sub_id,
  onCancel,
  visible,
}) => {
  // const myDayjsDate = dayjs(props.record.start_date, "YYYY-MM-DD");
  // console.log(myDayjsDate);

  const formRef = useRef();
  const handleCancel = () => {
    formRef.current.resetFields();
    onCancel();
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const onFinish = async (values) => {
    //console.log(values);
    const purchased_at = dayjs(values?.purchased_at);
    const additionalValues = {
      status: true,
      organization: org_id,
      purchases_doc: uploadedFiles,
      org_subscription_id: org_sub_id,
      allocated_type: "Fixed",
      purchased_at: purchased_at.format("YYYY-MM-DD"),
    };
    const newValues = { ...values, ...additionalValues };
    //console.log(newValues);
    try {
      await Axios.post("/tnviewpurchase/", newValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Created");
    } catch (err) {
      //console.log(err);
      CreateFailed("Created", err);
    }
  };
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [fileList, setFileList] = useState([]);
  const handleUpload = async (file) => {
    console.log(file);
    const file_name = await uploadFileCourse(file, "view", csrfToken);
    setUploadedFiles(file_name);
  };
  console.log(uploadedFiles);

  const handleChange = async (info) => {
    const file = info.file.originFileObj || info.file;
    const imageUrl = URL.createObjectURL(file);
    console.log(info);
    setFileList([
      {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: imageUrl,
        originFileObj: file,
      },
    ]);

    await handleUpload(file);
  };
  return (
    <Modal
      // title="My Modal"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      title={<p className="modal-heading">LMS VIEW PURCHASE</p>}
      centered
      width={850}
    >
      <Form
        name="complex-form"
        onFinish={onFinish}
        layout="vertical"
        ref={formRef}
        initialValues={{
          purchased_at: dayjs(),
        }}
        labelCol={{
          span: 25,
        }}
        wrapperCol={{
          span: 80,
        }}
        style={{
          width: "100%",
        }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="antd-test-client" style={{ marginTop: "2rem" }}>
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={10} lg={12} xl={12}>
                <Form.Item
                  label={<p className="my-form-lables">Description</p>}
                >
                  <Form.Item name="description">
                    <Input
                      placeholder="Enter your description"
                      name="description"
                      className="my-form-input-antd-test"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                <Form.Item
                  label={<p className="my-form-lables">Purchase Date</p>}
                >
                  <Form.Item
                    name="purchased_at"
                    rules={[
                      { required: true, message: "Purchase date is required" },
                    ]}
                  >
                    <DatePicker
                      placeholder="Select purchase date"
                      className="my-form-input-antd-test"
                      style={{ width: "100%" }}
                      defaultValue={dayjs()} // Ensures the DatePicker spans the full width
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={7} xl={7}>
                <Form.Item label={<p className="my-form-lables">Views</p>}>
                  <Form.Item name="purchased_view_count" noStyle>
                    <InputNumber
                      placeholder="Enter number of views"
                      name="purchased_view_count"
                      className="my-form-input-antd-test"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="antd-test-client">
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Amount</p>}>
                  <Form.Item name="amount" noStyle>
                    <InputNumber
                      placeholder="Enter amount"
                      name="amount"
                      className="my-form-input-antd-test"
                      addonAfter="$"
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                <Form.Item
                  label={<p className="my-form-lables">Purchase Status</p>}
                >
                  <Form.Item
                    noStyle
                    name="purchase_status"
                    rules={[
                      {
                        required: true,
                        message: "Purchase status is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Status"
                      className="my-form-input-antd-test"
                    >
                      <Option value="Pending">
                        <span>
                          <LoadingOutlined
                            style={{
                              color: "#faad14",
                              marginRight: "8px",
                            }}
                          />
                          Pending
                        </span>
                      </Option>
                      <Option value="Failed">
                        <span>
                          <CloseOutlined
                            style={{
                              color: "#ff4d4f",
                              marginRight: "8px",
                            }}
                          />
                          Failed
                        </span>
                      </Option>
                      <Option value="In Progress">
                        <span>
                          <SyncOutlined
                            spin
                            style={{
                              color: "#1890ff",
                              marginRight: "8px",
                            }}
                          />
                          In Progress
                        </span>
                      </Option>
                      <Option value="Success">
                        <span>
                          <CheckOutlined
                            style={{
                              color: "#52c41a",
                              marginRight: "8px",
                            }}
                          />
                          Success
                        </span>
                      </Option>
                    </Select>
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                <Form.Item
                  label={<p className="my-form-lables">File Upload</p>}
                >
                  <Form.Item
                    noStyle
                    name="purchases_doc"
                    style={{ width: "100%" }}
                  >
                    <Upload
                      name="purchases_doc"
                      listType="text"
                      beforeUpload={() => false} // Prevent automatic upload
                      style={{ width: "100%" }}
                      onChange={handleChange}
                      multiple={false}
                      customRequest={({ file }) => {}}
                      fileList={fileList}
                      accept=""
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{ width: "225px" }}
                      >
                        Click to Upload
                      </Button>
                    </Upload>
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#f58029",
                fontWeight: "600",
              }}
              className="save-update-btn"
            >
              Save
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddLMSPurchase;
